class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    // Update badge via API (smooth update)
    this.updateCartBadge();

    if (this.header) this.header.reveal();
    this.open();
  }

  // Update badge immediately from cart data (no API call needed)
  // Badge always exists in DOM - just toggle visibility
  updateCartBadgeFromData(itemCount) {
    const bubbleElement = document.getElementById('cart-icon-bubble');
    if (!bubbleElement) return;
    
    const currentBadge = bubbleElement.querySelector('.cart-count-badge');
    if (!currentBadge) return;
    
    // Update count first
    const countSpan = currentBadge.querySelector('span[aria-hidden="true"]');
    if (countSpan) {
      countSpan.textContent = itemCount < 100 ? itemCount : '99+';
    }
    
    // Toggle visibility (badge always in DOM)
    if (itemCount > 0) {
      currentBadge.classList.remove('cart-count-badge--hidden');
    } else {
      currentBadge.classList.add('cart-count-badge--hidden');
    }
    
    // Also update ATC button quantity on product page
    this.updateATCButtonQuantity(itemCount);
  }
  
  // Update ATC button quantity badge on product page
  updateATCButtonQuantity(itemCount) {
    const atcQtyBadge = document.querySelector('.product-sticky-atc__qty');
    if (!atcQtyBadge) return;
    
    if (itemCount > 0) {
      atcQtyBadge.textContent = itemCount < 100 ? itemCount : '99+';
      atcQtyBadge.style.display = 'flex';
    } else {
      atcQtyBadge.style.display = 'none';
    }
  }

  // Update cart badge by fetching cart data directly
  // Badge always exists in DOM - just toggle visibility (prevents flash)
  updateCartBadge() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const bubbleElement = document.getElementById('cart-icon-bubble');
        if (!bubbleElement) return;
        
        const currentBadge = bubbleElement.querySelector('.cart-count-badge');
        if (!currentBadge) return;
        
        // Update count first
        const countSpan = currentBadge.querySelector('span[aria-hidden="true"]');
        if (countSpan) {
          countSpan.textContent = cart.item_count < 100 ? cart.item_count : '99+';
        }
        
        // Toggle visibility (badge always in DOM)
        if (cart.item_count > 0) {
          currentBadge.classList.remove('cart-count-badge--hidden');
        } else {
          currentBadge.classList.add('cart-count-badge--hidden');
        }
        
        // Also update ATC button quantity on product page
        this.updateATCButtonQuantity(cart.item_count);
      })
      .catch(error => console.error('Error updating cart badge:', error));
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      // Note: cart-icon-bubble excluded for smooth badge update (no flash)
      // Badge updated via updateCartBadge() API call instead
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
